import React from 'react';
import AccountingModule from './accounting/Accounting';

const AccountsReceivable = (props) => (
  <AccountingModule ledgerType="receivables" {...props} />
);

export default AccountsReceivable;
